<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card animated zoomIn faster">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ selectedSlot.name }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div
          v-if="this.selectedSlot.code === 'PGSLOT' && hasPgSlotMessage"
          class="slot border"
        >
          <div class="text-alert" v-html="hasPgSlotMessage"></div>
        </div>
        <div
          v-else-if="isBetflixNew && selectedSlot.isActive"
          class="provider-game"
        >
          <div class="provider-list">
            <div
              v-for="provider in providers"
              :key="provider.game"
              class="provider-item"
              :class="{ 'is-selected': selectedProvider === provider.game }"
              @click="handleSelectProvider(provider.game)"
            >
              <img :src="provider.logo" :alt="provider.name" />
              <!-- <span>{{ provider.name }}</span> -->
            </div>
          </div>
          <div ref="gameList" class="game-list">
            <div
              v-for="game in games"
              :key="game.code"
              class="game-item"
              :class="{ 'is-selected': selectedGame === game.code }"
              @click="selectedGame = game.code"
              @dblclick="handlePlayGame(game.code)"
            >
              <img :src="game.img" :alt="game.name" />
              <span>{{ game.name }}</span>
            </div>
          </div>
        </div>
        <div
          v-else
          class="slot"
          v-bind:style="{ backgroundImage: `url(${selectedSlot.background})` }"
        >
          <img :src="selectedSlot.logo" />
        </div>
        <div v-if="selectedSlot.isActive">
          <div v-if="!isBetflixNew" class="field">
            <label for="" class="label copy"
              >Username
              <span
                class="copy"
                v-clipboard:copy="account.username"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <i class="fas fa-copy m-l-10"></i>
                {{ $t('modals.invite.copyTxt') }}</span
              ></label
            >
            <div class="control has-icons-left">
              <input
                type="text"
                placeholder="e.g. xxx xxx"
                class="input text-center"
                :value="account.username"
                readonly
              />
              <span class="icon is-small is-left">
                <i class="fas fa-user-tie"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <template v-if="!isBetflixNew">
              <label for="" class="label copy"
                >Password
                <span
                  class="copy"
                  v-clipboard:copy="account.password"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  <i class="fas fa-copy m-l-10"></i>
                  {{ $t('modals.invite.copyTxt') }}</span
                ></label
              >
              <div class="control has-icons-left">
                <input
                  placeholder="*******"
                  class="input text-center"
                  :value="account.password"
                  readonly
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-lock"></i>
                </span>
              </div>
            </template>
            <div v-if="!isBetflixNew">
              <span class="reset m-r-5" @click="handleResetPassword"
                ><i class="fas fa-sync-alt m-r-5"></i
                >{{ $t('modals.slotAccount.resetPasswordTxt') }}</span
              >
              <span class="note"
                >({{ $t('modals.slotAccount.canNotPlayTxt') }})</span
              >
            </div>
          </div>
          <div
            v-if="isBetflixNew"
            class="game-note"
            :class="{ 'is-selected': selectedGameName }"
          >
            {{ selectedGameName || $t('modals.slotAccount.selectGameTxt') }}
          </div>
          <div v-if="selectedSlot.web !== null" class="box-button m-t-10">
            <slot-login
              hidden
              :slot-code="selectedSlot.code"
              :url="selectedSlot.web"
              :account="account"
              :provider="selectedProvider"
              :game-code="selectedGame"
              :trigger="trigger"
            ></slot-login>
            <button
              class="button full-100 is-primary"
              @click="transferAndPlay"
              :disabled="isBetflixNew && !selectedGame"
            >
              {{ $t('modals.slotAccount.playGameBtn') }}
            </button>
          </div>
          <div v-else class="box-button m-t-10">
            <button
              class="button full-100 is-primary"
              @click="transferOnly"
              :disabled="amount <= 0"
            >
              {{ $t('modals.slotAccount.transferToGameLabel') }}
            </button>
          </div>
          <div v-if="!isBetflixNew" class="box-button m-t-10">
            <button
              class="button full-50 is-success"
              @click="handlePlayOnAndroid(selectedSlot.android)"
              :disabled="selectedSlot.android === null ? true : false"
            >
              {{ $t('modals.slotAccount.androidAppBtn') }}
            </button>
            <button
              class="button full-50 is-info"
              @click="handlePlayOniOS(selectedSlot.ios)"
              :disabled="selectedSlot.ios === null ? true : false"
            >
              {{ $t('modals.slotAccount.iosAppBtn') }}
            </button>
          </div>
        </div>
        <div v-else>
          <div class="box-button m-t-30">
            <button class="button full-100 is-primary" @click="handleActivate">
              {{ $t('modals.slotAccount.activeBtn') }}
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiWallet from '@/api/wallet'
import SlotLogin from '../login/index.vue'
import i18n from '@/language'
export default {
  name: 'ModalSlotAccount',
  components: {
    SlotLogin
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    selectedSlot: {
      type: Object
    },
    wallet: {
      type: Number
    }
  },
  data() {
    return {
      account: {},
      trigger: 0,
      amount: 0,
      hasPgSlotMessage: process.env.VUE_APP_MSG_PGSLOT,
      providers: [],
      games: [],
      selectedProvider: null,
      selectedGame: null
    }
  },
  computed: {
    isBetflixNew() {
      return this.selectedSlot.code === 'BETFLIXNEW'
    },
    selectedGameName() {
      const game = this.games.find(g => g.code === this.selectedGame)
      return game ? game.name : ''
    }
  },
  mounted() {
    this.amount = this.wallet

    if (this.isActive && this.selectedSlot.isActive === true) {
      this.getSlotAccout()
      this.getProvider()
    }
  },
  methods: {
    async transferAndPlay() {
      if (this.amount <= 0) {
        this.trigger += 1
        return
      }
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try {
        await this.transfer()
        this.trigger += 1
      } catch {}
    },
    async transferOnly() {
      if (this.amount <= 0) {
        this.$refs.inputAmount.focus()
        return
      }
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try {
        await this.transfer()

        this.$emit('closeModal', true)
        this.showSuccessAlert()
      } catch {}
    },
    async transfer() {
      let loading = this.$loading.show()

      return new Promise((resolve, reject) => {
        setTimeout(async () => {
          try {
            const result = await apiWallet.transferAllToGame(
              this.selectedSlot.code
            )
            if (result) {
              resolve()
            }
          } catch (error) {
            this.showErrorAlert(error)
            reject()
          } finally {
            loading.hide()
          }
        }, 200)
      })
    },
    showSuccessAlert() {
      this.$swal(
        i18n.t('modals.successMsg'),
        i18n.t('modals.transferMsg'),
        'success'
      )
    },
    showErrorAlert(text) {
      this.$swal(i18n.t('modals.errorMsg'), text, 'error')
    },
    async getSlotAccout() {
      const data = await apiWallet.accountSlot(this.selectedSlot.code)
      this.account = data
    },
    async getProvider() {
      if (!this.isBetflixNew) return

      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try {
        const data = await apiWallet.providerSlot(this.selectedSlot.code)
        this.providers = Array.isArray(data) ? data : []
      } catch {}

      if (this.providers.length > 0)
        await this.handleSelectProvider(this.providers[0].game)
    },
    async handleSelectProvider(provider) {
      if (this.selectedProvider === provider) return

      this.selectedProvider = provider
      this.selectedGame = null
      this.games = []

      // wait for game list container to render on first load
      await this.$nextTick()
      let loading = this.$loading.show({
        container: this.$refs.gameList,
        isFullPage: false,
        backgroundColor: '#484848',
        color: '#fff'
      })
      try {
        const data = await apiWallet.gameSlot(this.selectedSlot.code, provider)
        // ignore stale response if user switched provider meanwhile
        if (this.selectedProvider === provider)
          this.games = Array.isArray(data) ? data : []
      } catch {
      } finally {
        loading.hide()
      }
    },
    handlePlayGame(gameCode) {
      // play button only exists when slot has a web url
      if (this.selectedSlot.web === null) return

      this.selectedGame = gameCode
      this.transferAndPlay()
    },
    closeModal() {
      this.$emit('closeModal', null)
    },
    handleActivate() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          await apiWallet.activateSlot(this.selectedSlot.code)
          this.selectedSlot.isActive = true

          await this.getSlotAccout()
          await this.getProvider()

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    handleResetPassword() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          await apiWallet.resetPasswordSlot(this.selectedSlot.code)
          this.selectedSlot.isActive = true

          await this.getSlotAccout()

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    async handlePlayOnAndroid(url) {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      let win
      if (this.amount <= 0) {
        win = window.open('about:blank')
        win.location = url

        return
      }

      try {
        await this.transfer()
        win = window.open('about:blank')
        win.location = url
      } catch {}
    },
    async handlePlayOniOS(url) {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      let win
      if (this.amount <= 0) {
        win = window.open('about:blank')
        win.location = url

        return
      }

      try {
        await this.transfer()
        win = window.open('about:blank')
        win.location = url
      } catch {}
    },
    onCopy(e) {
      this.$buefy.toast.open({
        message: `copied: ${e.text}`,
        type: 'is-success'
      })
    },
    onError() {
      this.$buefy.toast.open({
        message: 'Failed to copy',
        type: 'is-danger'
      })
    }
  }
}
</script>

<style scoped lang="scss">
img {
  width: auto;
  height: 60px;
  margin-top: 20px;
  display: block;
  margin: 0 auto;
}

.modal-card-body {
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
}

.slot {
  position: relative;
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  width: 100%;
  height: 150px;
  text-align: center;
  display: block;
  opacity: 0.8;
  padding: 10px;
  margin-bottom: 20px;

  img {
    width: auto;
    height: 100px;
    margin-top: 15px;
  }

  .slot-container {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.4);
    color: #fff;
    bottom: 0;
    min-width: 100%;
    height: 60px;
    text-align: center;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    display: table;

    .slot-content {
      display: table-cell;
      vertical-align: middle;
      .slot-amount {
        font-weight: 700;
        font-size: 18px;
      }
      .slot-title {
        font-size: 12px;
      }
    }
  }

  &.border {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #222;
  }

  .text-alert {
    font-size: 18px;
    color: red;
  }
}

.provider-game {
  display: flex;
  height: 360px;
  margin-bottom: 20px;
  border-radius: 10px;

  .provider-list,
  .game-list {
    overflow-y: auto;
    background-color: #1a1a1a;
    color: #fff;
  }

  .provider-list {
    flex: 0 0 80px;

    .provider-item {
      font-size: 10px;
      margin: 5px;

      img {
        width: 40px;
        height: 40px;
        object-fit: contain;
      }
    }
  }

  .game-list {
    position: relative;
    background-color: #888888;
    flex: 1;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
    grid-auto-rows: min-content;
    gap: 8px;
    padding: 10px;
  }

  .provider-item,
  .game-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px;
    border: 1px solid #333;
    border-radius: 8px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;

    &:hover,
    &.is-selected {
      border-color: $primary;
    }

    img {
      width: 100%;
      height: auto;
      margin: 0 auto 4px;
    }
  }

  .game-item {
    position: relative;
    transition: transform 0.15s ease, box-shadow 0.15s ease,
      background-color 0.15s ease;

    // same image box for every game, crop to fill
    img {
      aspect-ratio: 1 / 1;
      object-fit: cover;
      object-position: center;
      border-radius: 6px;
      transition: filter 0.15s ease;
    }

    // limit name to 2 lines so tiles have equal height
    span {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      line-height: 1.3;
      min-height: 2.6em;
    }

    &:hover {
      transform: translateY(-2px);
    }

    &.is-selected {
      transform: scale(1.05);
      background-color: rgba($primary, 0.25);
      box-shadow: 0 0 0 2px $primary, 0 0 12px rgba($primary, 0.8);
      font-weight: 700;
      z-index: 1;

      img {
        filter: brightness(1.1);
      }

      // check badge on the top-right corner
      &::after {
        content: '\2713';
        position: absolute;
        top: -6px;
        right: -6px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        border-radius: 50%;
        background-color: $primary;
        color: #fff;
        font-size: 12px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
      }
    }
  }
}

.game-note {
  text-align: center;
  font-size: 14px;
  color: $danger;

  &.is-selected {
    font-weight: 700;
    color: #1a1a1a;
  }
}

label {
  &.copy {
    &:hover {
      cursor: pointer;
      color: $primary;
    }
  }
}

.reset {
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: $primary;
  }
}

.note {
  font-size: 14px;
  color: $danger;
}

.height-0 {
  height: 0px !important;
  visibility: hidden;
}
</style>
